import { render, staticRenderFns } from "./CustomerServices.vue?vue&type=template&id=7946f38e&scoped=true"
import script from "./CustomerServices.vue?vue&type=script&lang=ts"
export * from "./CustomerServices.vue?vue&type=script&lang=ts"
import style0 from "./CustomerServices.vue?vue&type=style&index=0&id=7946f38e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7946f38e",
  null
  
)

export default component.exports